export default __webpack_public_path__ + "static/media/team12.1f021fb0.JPG";